<template>
	<div class="wrapper">
		<div class="t bgw">
			<div class="shop-container">
				<router-link to="/">
					<div class="logo-icon">
						<img src="@/assets/images/sld.jpg" alt />
						<!-- <img :src="this.$store.state.config.shop_logo" alt> -->
					</div>
					<div class="logo-text">{{ this.$store.state.config.shop_name }}</div>
				</router-link>
			</div>
		</div>
		<div class="main shop-container">
			<div class="timetip bgw">
				<i class="icon iconfont iconerror"></i>
				<template>
					<span>{{ hour ? hourString + ':' + minuteString + ':' + secondString : minuteString + ':' + secondString }}</span>
				</template>
				{{ $t('countDownTips') }}
			</div>
			<div class="count-title bgw">
				<div class="l">
					<div class="head" style="margin-right:10px;">{{ $t('project') }}：</div>
					<div class="item-list">
						<div v-for="(item, index) in orderInfo.items" :key="index" class="item-li">{{ item.name }}</div>
					</div>
				</div>
				<div class="total">
					{{ this.$t('currencySymbol') }}
					<span class="total-money">{{ orderInfo.order_amount }}</span>
				</div>
			</div>
			<div class="pay-box bgw">
				<div class="title">Payment Method</div>
				<div class="box-info">
					<el-radio-group v-model="payType">
						<el-radio :label="item.code" v-for="(item, index) in payments" :key="index">
							<span class="pay-type" :class="{ active: payType == item.code }">
								<i class="icon iconfont iconxianxiamendian" v-if="item.code == 'offline'"></i>
								<i class="icon iconfont iconyuezhifu" v-else-if="item.code == 'balancepay'"></i>
								<i class="icon iconfont iconzhifubao" v-else-if="item.code == 'alipay'"></i>
								<i class="icon iconfont iconweixinzhifu" v-else-if="item.code == 'wechatpay'"></i>
								{{ item.name }}
							</span>
						</el-radio>
					</el-radio-group>
				</div>
				<!-- <div class="msg">Note: Please email us at 
					info@sanlidaarchery.com
					 once payment is completed while your order information not yet changed. </div>
				<div class="msg">Do Not Repeat Your Payment Process*</div> -->

				<div class="msg">*After payment completed, please wait a few seconds till the information to be uploaded. If any error occurred, please Do Not Pay Again!</div>
				<div class="msg">Contact customer service: <a class="email">info@sanlidaarchery.com</a></div>
				
				<div class="help">
					<div v-for="(item,index) in help_list" :key="index" class="title">
						<router-link target="_blank" :to="{path:'/helpdetail',query:{article_id:item.id}}">• {{item.title}}</router-link>
					</div>
				</div>


				<div class="pay-block">
					<div class="pay-info">
						{{ this.$t('currencySymbol') }}
						<span class="total-money">{{ orderInfo.order_amount }}</span>
					</div>
				</div>
				<div class="pay-block">
					<el-button class="pay-btn" :loading="btnLoading" @click="toPay" :disabled="paytimer < 60">
						<span v-if="paytimer < 60">{{paytimer}}s</span>
						<span v-else>Pay Now</span>
					</el-button>
				</div>
			</div>
		</div>
		<template v-if="dialogPaymentShow">
			<Payment :codeImg="code_url" @clearInterPay="clearInterPay"></Payment>
		</template>

		<el-dialog :visible.sync="tipsDia" title="Tips" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
			<div>
				<div class="form-top">
					<i class="el-icon-s-opportunity"></i>
					<div class="r">
						<!-- <div class="r-top">Please do not close the payment verification window before the payment is completed.</div>
						<div class="r-bot">After the payment is completed, please click the button below according to your payment situation.</div> -->

						<div class="r-top">Redirecting to Paypal Checkout Page, Please Wait (5s)</div>
						<div class="r-bot">If there is an error occurred, please select bottoms accordingly.</div>


					</div>
				</div>
				<div class="form-foot">
					<div class="foot-btn cancel" @click="orderDetail">Paid Fail</div>
					<div class="foot-btn save" @click="orderDetail">Paid Success</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Payment from '@/components/payment.vue';
import { locationHost } from '@/config/env.js';
export default {
	name: 'Cashier',
	components: { Payment },
	props: {},
	data() {
		return {
			payments: [],
			payType: 'alipay',
			orderInfo: {},
			code_url: '',
			dialogPaymentShow: false,
			intervalPayStatus: '',
			remainingTime: '',
			hour: '',
			minute: '',
			second: '',
			promiseTimer: '',
			btnLoading: false, // 禁用btn
			tipsDia: false,
			paytimer: 60,
      		auth_timer: "",
			help_list:[]
		};
	},
	watch: {},
	computed: {
		hourString() {
			return this.formatNum(this.hour);
		},
		minuteString() {
			return this.formatNum(this.minute);
		},
		secondString() {
			return this.formatNum(this.second);
		},
		//商品总数量
		// 计算购物车商品数量
		productNums() {
			let nums = 0;
			for (let i in this.orderInfo.items) {
				nums += parseFloat(this.orderInfo.items[i].nums);
			}
			return nums;
		}
	},
	methods: {
		// 去订单页面
		orderDetail() {
			this.$router.replace({
				path: '/center/myOrder'
			});
		},
		countDownTime() {
			let auth_timer = setInterval(() => {
				// 定时器设置每秒递减
				this.paytimer--; // 递减时间
				this.$storage.set(this.$route.params.order_id + 'get_pay_time', this.paytimer)

				if(this.paytimer % 10 == 0) {
					
				}
				this.btnLoading = true

				if (this.paytimer <= 0) {
					this.btnLoading = false
					this.verification = true; // 60s时间结束还原v-show状态并清除定时器
					this.paytimer = 60;
					clearInterval(auth_timer);
					this.$storage.remove(this.$route.params.order_id + 'get_pay_time', 60)
					this.$storage.remove(this.$route.params.order_id + 'PAY_TIME')
				}
			}, 1000);
		},

		checkTimeClick() {
			const now = new Date().getTime()

			this.paytimer = this.$storage.get(this.$route.params.order_id + 'get_pay_time') || 60

			const localTime = this.$storage.get(this.$route.params.order_id + 'PAY_TIME') || 0

			if(localTime > 0 && (now - localTime < 60000)) {
				this.countDownTime()
			}

		},
		toPay() {
			this.btnLoading = true;
			let code = this.payType;
			this.$storage.set(this.$route.params.order_id + 'PAY_TIME', new Date().getTime())
			this.checkTimeClick()
			
			if (code == 'wechatpay') {
				let data = {
					ids: this.order_id,
					payment_code: code,
					payment_type: 1,
					params: {
						trade_type: 'NATIVE'
					}
				};
				// 微信h5支付
				this.$api
					.pay(data)
					.then(res => {
						this.btnLoading = false;
						if (res.status) {
							this.dialogPaymentShow = true;
							this.code_url = res.data.code_url;
							this.getPaymentStatus(res.data.payment_id);
						} else {
							this.$msg(res.msg, 'error');
						}
					})
					.catch(() => {
						this.btnLoading = false;
					});
			} else if (code == 'alipay') {
				let data = {
					ids: this.order_id,
					payment_code: code,
					payment_type: 1,
					params: {
						trade_type: 'PC',
						return_url: locationHost + '/cashier/' + this.order_id
					}
				};
				this.$api
					.pay(data)
					.then(res => {
						this.btnLoading = false;
						if (res.status) {
							this.standarPost(res.data.url, res.data.data);
						}
					})
					.catch(() => {
						this.btnLoading = false;
					});
			} else if (code == 'balancepay') {
				let data = {
					ids: this.order_id,
					payment_code: code,
					payment_type: 1
				};
				this.$api
					.pay(data)
					.then(res => {
						this.btnLoading = false;
						if (res.status) {
							this.$msg(this.$t('paySucess'));
							console.log(1);
							this.toPaySuccess();
						} else {
							this.$msg(res.msg, 'warning');
						}
					})
					.catch(() => {
						this.btnLoading = false;
					});
			} else if (code == 'offline') {
				this.$confirm(this.$t('paymentofflineTitle'), this.$t('offlineExplain'), {
					confirmButtonText: this.$t('orderDetail'),
					cancelButtonText: this.$t('next'),
					type: 'info'
				})
					.then(() => {
						this.btnLoading = false;
						this.$router.replace({
							name: 'orderDetail',
							params: { order_id: this.order_id }
						});
					})
					.catch(() => {
						this.btnLoading = false;
						this.$router.replace({ name: 'home' });
					});
			} else if (code == 'paypal') {
				let data = {
					ids: this.order_id,
					payment_code: code,
					payment_type: 1,
					params: {
						trade_type: 'PC',
						// return_url: locationHost + 'web/cashier/' + this.order_id
						return_url: locationHost + 'web/PaySuccess'

					}
				};
				this.tipsDia = true;
				this.$api
					.pay(data)
					.then(res => {
						this.btnLoading = false;
						if (res.status) {
							// window.open(href)
							window.location.href = res.data.url;
							// this.standarPost(res.data.url);
						}
					})
					.catch(() => {
						this.btnLoading = false;
					});
			} else if(code == 'stripe') {
				console.log('fdhbgfch')
				let data = {
					ids: this.order_id,
					payment_code: code,
					payment_type: 1,
					params: {
						trade_type: 'PC',
						// return_url: locationHost + 'web/cashier/' + this.order_id
						return_url: locationHost + 'web/PaySuccess'
				
					}
				};
				this.tipsDia = true;
				this.$api
					.pay(data)
					.then(res => {
						this.btnLoading = false;
						if (res.status) {
							// window.open(href)
							window.location.href = res.data.url;
							// this.standarPost(res.data.url);
						}
					})
					.catch(() => {
						this.btnLoading = false;
					});
			}
		},
		standarPost(url, data) {
			let tempForm = document.createElement('form');
			tempForm.id = 'aliPay';
			tempForm.methods = 'post';
			tempForm.action = url;
			tempForm.target = '_self';
			let input = [];
			for (let k in data) {
				input[k] = document.createElement('input');
				input[k].type = 'hidden';
				input[k].name = k;
				input[k].value = data[k];
				tempForm.appendChild(input[k]);
			}
			tempForm.addEventListener('submit', function() {}, false);
			document.body.appendChild(tempForm);
			tempForm.dispatchEvent(new Event('submit'));
			tempForm.submit();
			document.body.removeChild(tempForm);
		},
		clearInterPay() {
			clearInterval(this.intervalPayStatus);
			this.dialogPaymentShow = false;
		},
		toPaySuccess() {
			this.$router.replace({
				name: 'paySuccess',
				query: { order_id: this.order_id }
			});
		},
		getPaymentStatus(id) {
			let data = {
				payment_id: id
			};
			let that = this;
			this.intervalPayStatus = setInterval(function() {
				that.$api.paymentInfo(data).then(res => {
					if (res.status) {
						if (res.data.status == 2) {
							that.$msg(that.$t('paySucess'));
							that.toPaySuccess();
						}
					}
				});
			}, 1000);
		},
		getPaymentType() {
			this.$api.paymentList().then(res => {
				let data = res.data;
				this.payments = data;
			});
		},
		getOrderDetail() {
			let data = {
				order_id: this.order_id
			};
			this.$api.orderDetail(data).then(res => {
				if (res.status) {
					this.orderInfo = res.data;
					let remainingTime = res.data.remaining_time;
					this.remainingTime = remainingTime;
					this.getCountDownTime(remainingTime);
					//这里先注册，防止重复数据
					/* this.googleAd();
					this.facebookAd(); */
					/* if(this.$route.params.type && this.$route.params.type == 'success') {
           
			
          } */
					if (res.data.pay_status == 2) {
						this.toPaySuccess();
					}
				}
			});
		},
		googleAd() {
			let orders = this.$storage.get('google_orders') || [];

			if (orders.length > 0 && orders.indexOf(this.order_id) > -1) {
				return true;
			}
			window.dataLayer = window.dataLayer || [];

			let items = [];
			let transactionProducts = [];

			for (let i of this.orderInfo.items) {
				items.push({ id: i.product_id, google_business_vertical: 'retail' });

				transactionProducts.push({ sku: i.addon, name: i.name, price: i.price, quantity: i.nums });
			}
			// Universal Analytics 电子商务
			window.dataLayer.push({
				transactionId: this.orderInfo.order_id, // 订单号？
				transactionTotal: this.orderInfo.order_amount, // 商品总价格？
				transactionProducts: transactionProducts,
				currency: 'USD'
			});
			// Google Ads 动态再营销
			window.dataLayer.push({
				event: 'purchase', // 购买操作
				value: this.orderInfo.order_amount, // 这个 值哪里来的
				items: items,
				transaction_id: this.orderInfo.order_id,
				currency: 'USD'
			});
			orders.push(this.order_id);
			this.$storage.set('google_orders', orders);
			console.log('dataLayer', window.dataLayer);
		},
		facebookAd() {
			let orders = this.$storage.get('facebook_orders') || [];

			if (orders.length > 0 && orders.indexOf(this.order_id) > -1) {
				return true;
			}
			let userInfo = this.$storage.get('userInfo');
			let items = [];
			let content_ids = [];

			for (let i of this.orderInfo.items) {
				items.push({ id: i.product_id, quantity: i.nums });
				content_ids.push(i.product_id);
			}
			let purchase = {
				content_ids: content_ids,
				content_name: this.orderInfo.order_id,
				content_type: 'product_group',
				contents: items,
				num_items: this.productNums,
				currency: 'USD',
				value: this.orderInfo.order_amount
			};
			window.fbq('track', 'Purchase', purchase);
			orders.push(this.order_id);
			this.$storage.set('facebook_orders', orders);
		},
		getCountDownTime(time) {
			if (Number(time) > 0) {
				this.hour = Math.floor(time / 3600);
				this.minute = Math.floor((time / 60) % 60);
				this.second = Math.floor(time % 60);
				this.countDown();
			}
		},
		countDown() {
			let that = this;
			clearInterval(this.promiseTimer);
			this.promiseTimer = setInterval(function() {
				if (that.hour === 0) {
					if (that.minute !== 0 && that.second === 0) {
						that.second = 59;
						that.minute -= 1;
					} else if (that.minute === 0 && that.second === 0) {
						that.second = 0;
						clearInterval(that.promiseTimer);
					} else {
						that.second -= 1;
					}
				} else {
					if (that.minute !== 0 && that.second === 0) {
						that.second = 59;
						that.minute -= 1;
					} else if (that.minute === 0 && that.second === 0) {
						that.hour -= 1;
						that.minute = 59;
						that.second = 59;
					} else {
						that.second -= 1;
					}
				}
			}, 1000);
		},
		formatNum(num) {
			return num < 10 ? '0' + num : ' ' + num;
		},
		
		//获取帮助中心列表
		getArticleList(id) {
		  let data = {
			type_id: id,
			page: 1,
			limit: 10
		  }

		  this.$api.articleList(data).then(res => {
			if (res.status) {
				this.help_list = res.data.list;
			}
		  })
		},
	},
	mounted() {
		//console.log('(this.$route.params.query', this.$route.query)
		if (this.$route.query && this.$route.query.id) {
			this.tipsDia = true;
			
    		// if (this.$storage.get("userToken")) {
			// 	this.$api.paymentInfo({}).then(res => {

			// 	})
			// }
		}

		// this.checkTimeClick()
		let orderId = this.$route.params.order_id;
		this.order_id = orderId;
		this.getPaymentType();
		this.getOrderDetail();
		this.getArticleList(44);
		
		//console.log(this.payments);
	},
	destroyed() {
		clearInterval(this.promiseTimer);
		clearInterval(this.intervalPayStatus);
	}
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
@import '@/assets/css/mixin.scss';
.wrapper {
	.main {
		.timetip {
			height: 40px;
			line-height: 40px;
			text-align: center;
			margin: 16px auto;
			color: #757575;
			.icon {
				color: #757575;
				margin-right: 5px;
			}
		}
		.count-title {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			padding: 14px;
			margin-bottom: 10px;
			.l {
				display: inline-flex;
				.head {
					width: 60px;
					height: 30px;
					line-height: 30px;
				}
				.item-list {
					.item-li {
						height: 30px;
						line-height: 30px;
					}
				}
			}
			.total {
				color: $theme-color;
				font-size: 12px;
				height: 30px;
				line-height: 30px;
				&-money {
					font-size: 24px;
				}
			}
		}
		.pay-box {
			padding: 14px;
			margin-bottom: 20px;
			.title {
				margin-bottom: 20px;
			}
			.box-info {
				display: flex;
				margin-bottom: 40px;
				.pay-type {
					display: inline-block;
					width: 130px;
					height: 36px;
					line-height: 32px;
					text-align: center;
					border: 1px solid $border;
					transition: all 0.2s;
					cursor: pointer;
					padding: 1px;
					box-sizing: border-box;
					&.active,
					&:hover {
						border-color: $theme-color;
					}
				}
			}
			.pay-block {
				height: 50px;
				.pay-info {
					float: right;
					color: $theme-color;
					.total-money {
						font-size: 24px;
					}
				}
				.pay-btn {
					float: right;
					// width: 90px;
					// height: 32px;
					line-height: 6px;
					border-radius: 16px;
					text-align: center;
					background: $theme-color;
					color: #fff;
					cursor: pointer;
				}
			}
		}
	}

	.t {
		border-bottom: 2px solid $theme-color;
		height: 100px;
		.shop-container {
			padding-top: 30px;
			.logo-icon {
				float: left;
				width: 200px;
				height: 60px;
				margin-right: 10px;
				img {
					width: 100%;
					height: auto;
				}
			}
			.logo-text {
				float: left;
				margin-top: 0px;
				font-size: 20px;
				color: #424242;
				line-height: 48px;
				margin-right: 20px;
			}
			.tip {
				float: left;
				line-height: 20px;
				margin-top: 20px;
				font-size: 12px;
				color: #757575;
			}
			.group {
				float: right;
				margin-top: 20px;
				display: flex;
				color: #757575;
				font-size: 12px;
				.item {
					height: 40px;
					line-height: 40px;
					cursor: pointer;
				}
				.line {
					height: 20px;
					line-height: 20px;
					color: #757575;
					margin-top: 10px;
					margin: 10px 10px 0;
				}
			}
		}
	}
}

.form-top {
	display: flex;
	.el-icon-s-opportunity {
		font-size: 50px;
		color: #e7442f;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-left: 20px;
	}
	.r {
		font-size: 14px;
		padding: 0 20px;
		&-top {
			margin: 30px 0;
		}
		&-bot {
			margin: 30px 0;
		}
	}
}

.form-foot {
	display: flex;
	justify-content: center;
	padding: 20px 0;
	background: #f5f5f5;
	.foot-btn {
		width: 160px;
		text-align: center;
		height: 40px;
		line-height: 40px;
		color: #fff;
		cursor: pointer;
		&.save {
			background: $theme-color;
			margin-right: 20px;
			margin-left: 20px;
		}
		&.cancel {
			background: #b0b0b0;
			transition: all 0.2s;
			&:hover {
				background: #757575;
			}
		}
	}
}

.msg {
	color: #e7442f;
	padding: 10px 0;
}

.help {
	width:100%;
	padding-top:20px;
	.title{
		float: left;
		color: #000000;
		padding-right: 30px;
		line-height: 35px;
		cursor: pointer;
	}
}

.email {
	cursor: pointer;
	text-decoration:underline;
	color: #044d97;
}
</style>
